import { render } from "./RegistrationLinkCard.vue?vue&type=template&id=00da1cee&scoped=true&ts=true"
import script from "./RegistrationLinkCard.vue?vue&type=script&lang=ts"
export * from "./RegistrationLinkCard.vue?vue&type=script&lang=ts"

import "./RegistrationLinkCard.vue?vue&type=style&index=0&id=00da1cee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00da1cee"]])

export default __exports__